import EmptyLayout from "@/layout/empty";
export default [{
        path: "",
        name: 'Layout',
        redirect: "/index",
        component: EmptyLayout,
        children: []
    },
    {
        path: "/iconSelect",
        name: 'iconSelect',
        component: () =>
            import (`@/views/iconSelect`),
        children: []
    }

];


// WEBPACK FOOTER //
// ./src/router/modules/system.js